<template>
    <div>
        <draggable
            tag="ul"
            v-model="files"
            v-if="files.length"
            class="g-upload-media-list list-unstyled"
            @end="reorder"
            handle=".g-upload-media-handle"
        >
            <template v-for="(mediaItem, index) in files">
                <li class="g-upload-media-list-item" @click.prevent="clickMedia(mediaItem)" v-if="mediaItem">
                    <table class="g-upload-preview">
                        <tr>
                            <td class="g-upload-preview-image">
                                <display-media
                                    :description="false"
                                    :media="mediaItem"
                                    :key="'previewlistItem' + index"
                                    height="70px"
                                    width="70px"
                                ></display-media>
                            </td>
                            <td class="g-upload-preview-body">
                                <div class="g-upload-media-name">
                                    {{ mediaItem.file_name }}
                                </div>
                                <div class="text-muted">( {{ mediaItem.size | humanFileSize }} )</div>
                            </td>
                            <td class="g-upload-preview-actions">
                                <button ref="deleteBtn" class="btn btn-plain button-delete" @click.stop="deleteMedia($event, index)">
                                    <span class="sr-only">Remove Media</span>
                                    <i class="fal fa-times"></i>
                                </button>
                                <i class="fal fa-arrows g-upload-media-handle m-2" v-if="files.length > 1"></i>
                            </td>
                        </tr>
                    </table>
                </li>
            </template>
        </draggable>
    </div>
</template>

<script>
import { humanFileSize, fileInputFilter } from '../util';

export default {
    props: {
        value: {},
        preview: {
            default: true,
        },
    },
    data() {
        return {
            files: [],
        };
    },
    filters: {
        humanFileSize,
    },
    methods: {
        fileInputFilter: fileInputFilter,
        clickMedia(media) {
            if (this.preview) {
                this.$emit('click-media', media);
            }
        },
        deleteMedia(e, index) {
            this.emitInput(
                _.filter(this.files, (value, key) => {
                    return key !== index;
                }),
            );
        },
        reorder() {
            this.emitInput(this.files);
        },
        emitInput(newVal) {
            this.$emit('input', newVal);
        },
    },
    watch: {
        value: {
            deep: true,
            immediate: true,
            handler(newVal) {
                Vue.set(this, 'files', _.isNull(newVal) ? [] : _.castArray(newVal));
            },
        },
    },
};
</script>

<style lang="scss">
.sortable-ghost {
    background: #119dea;
}

.g-upload-media-list {
    border-radius: 5px;
    border: 1px solid #ddd;
    padding: 8px;
    width: 100%;
    margin-bottom: 5px;

    .g-upload-media-list-item {
        position: relative;
        cursor: pointer;
    }

    .g-upload-preview {
        width: 100%;
        height: 80px;

        td {
            max-height: 80px;
            padding: 5px;
        }

        .g-upload-preview-image {
            position: relative;
            width: 80px;
            height: 80px;
            padding: 5px;
            cursor: pointer;

            img {
                /*position: absolute;*/
                /*top: 50%;*/
                /*left: 50%;*/
                /*transform: translateX(-50%) translateY(-50%);*/
                max-width: 100%;
                max-height: 100%;
                padding: 2px;
            }
        }

        .g-upload-preview-body {
            font-size: 14px;

            .g-upload-media-name {
                cursor: pointer;
            }
        }

        .g-upload-preview-actions {
            text-align: right;

            .btn {
                margin: 0.5em;
            }

            .btn:active,
            .btn:hover {
                color: rgb(33, 37, 41);
            }
        }
    }

    .media {
        cursor: pointer;
        position: relative;
        z-index: 1;
    }

    .g-upload-preview:hover {
        background-color: rgba(0, 0, 0, 0.075);
    }

    .media-actions {
        padding-right: 60px;
    }
}
</style>
